var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","position":"relative"}},[_c('div',{staticClass:"workbench",style:({
              width: _vm.screenProps.width + 'px',
              height: _vm.screenProps.height + 'px',
              'background-color': _vm.screenProps.backgroundColor
            }),attrs:{"id":"workbench"}},_vm._l((_vm.widgetViewList),function(widgetItem,index){return _c('div',{key:index,staticClass:"widget-item",style:({
            width: widgetItem.widgetProps.viewProps.width + 'px',
            height: widgetItem.widgetProps.viewProps.height + 'px',
            top: widgetItem.widgetProps.viewProps.top + 'px',
            left: widgetItem.widgetProps.viewProps.left + 'px',
         })},[_c(widgetItem.widgetProps.widgetViewName,{tag:"component",attrs:{"widget-data":widgetItem.widgetProps}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }